<template>
  <div class="user-tab">
    <div
      v-for="(item, index) in state.tabs"
      class="tab-item"
      :class="{ activeClass: activeId === item.id, [item.class]: true }"
      :key="index"
      @click="goLink(item)"
    >
      <img class="bell" v-if="item.isBell" src="@/assets/images/guide/bell.gif" />

      {{ item.label }}
    </div>
  </div>
</template>
<script setup>
import { computed, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
const { t } = useI18n()
const $router = useRouter()
const $route = useRoute()
const state = reactive({
  tabs: [
    { label: t('home.purchaseAgent'), code: '', id: 1 },
    // { label: t('home.category'), link: 'classifier', id: 5 },
    { label: t('home.transport'), link: 'transport', id: 6 },
    { label: t('home.manualOrdering'), link: 'uni-order', id: 2 },
    { label: t('home.guideBook'), link: 'shopping-guide', class: 'main', isBell: true, id: 3 },
    { label: t('home.help'), code: 'help-center', id: 4 },
    { label: t('home.event'), link: 'activity-notice', id: 7 },
  ],
})
const activeId = computed(() => {
  let id = null
  switch ($route.name) {
    case 'home':
      id = 1
      break
    case 'uni-order':
      id = 2
      break
    case 'faq':
      if ($route.query.code === 'ACBUY-222') {
        id = 3
      }
      break
    case 'helpCenter':
      id = 4
      break
    case 'classifier':
      id = 5
      break
    case 'transport':
      id = 6
      break
    case 'activity-notice':
      id = 7
      break
    default:
      break
  }
  return id
})

const goLink = ({ link, code }) => {
  if (code) {
    if (code === 'help-center') {
      window.open('/help-center', '_blank')
    } else {
      window.open(`/doc?code=${code}`, '_blank')
    }
  } else if (link) {
    $router.push({ name: link })
  } else {
    $router.push({ name: 'home' })
  }
}
</script>
<style lang="scss" scoped>
.user-tab {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // position: absolute;
  // left: 218px;
  // top: 0;
  height: 80px;

  // margin-left: 32px;
  // width: 634px;
  .tab-item {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 500;
    color: var(--black-color-9);
    margin-left: 24px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.main {
      color: var(--primary-color);
    }

    .bell {
      width: 20px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }

  .activeClass {
    color: var(--primary-color);
  }
}
</style>
